import { ConfirmDialog } from "@/ds";
import {
  ANEXO_REMOCAO_CANCELAR_LABEL,
  ANEXO_REMOCAO_CONFIRMAR_LABEL,
  ANEXO_REMOCAO_TITLE,
} from "./ficha-anexo-remocao.constants";
import type { FichaAnexoRemocaoProps } from "./types-ficha-anexo-remocao";

export function FichaAnexoRemocaoView({
  identificacao,
  onConfirmar,
  onCancelar,
}: FichaAnexoRemocaoProps) {
  return (
    <ConfirmDialog
      visible
      variant="destructive"
      className="p-dialog-anexo"
      header={ANEXO_REMOCAO_TITLE}
      message={
        <span>
          O arquivo <strong>&quot;{identificacao}&quot;</strong> sai dos anexos desta ficha. Não dá
          para desfazer.
        </span>
      }
      acceptLabel={ANEXO_REMOCAO_CONFIRMAR_LABEL}
      rejectLabel={ANEXO_REMOCAO_CANCELAR_LABEL}
      accept={onConfirmar}
      reject={onCancelar}
      onHide={onCancelar}
      testId="ficha-anexo-remocao"
    />
  );
}
